export const calculateGridColumnSpan = (numberOfOptions: number, maxNumberOfColumns: number) => {
  const columnNumber =
    numberOfOptions === 1
      ? maxNumberOfColumns
      : numberOfOptions === 3
      ? maxNumberOfColumns / 3
      : maxNumberOfColumns / 2;
  return columnNumber;
};
